<div class="clare-list-header-container mat-elevation-z">
    <div class="mat-card-header" fxLayout="row">
        <h2 class="mat-card-title" *ngIf="title">
            {{ title }}
            <span class="title-number" *ngIf="shouldDisplayItemCount">{{ dataSourceLength }}</span>
        </h2>
        <div class="buttonWrapper" fxFlex="1 1">
            <ng-container *ngIf="!isLoading"
                ><ng-content *ngxPermissionsOnly="['manageReplacePanel']" select="[replacePanel]"></ng-content
            ></ng-container>
            <ng-content *ngxPermissionsOnly="['manageRemoveZWave']" select="[removeZwave]"></ng-content>
            <span *ngxPermissionsOnly="checkPermissions(addButtonText || title) ? ['manageAddDevices'] : ''">
                <button
                    *ngIf="shouldEnableAddButton && !isLoading"
                    mat-stroked-button
                    id="btnAdd"
                    color="primary"
                    [class.new-primary-button]="!useAlternateAdd"
                    (click)="onAdd()"
                >
                    <ng-container i18n="@@SHARED.BTN.ADD">Add</ng-container>
                    {{ addButtonText || title }}
                </button>
            </span>
        </div>
    </div>
    <ng-content select="[selectListFilter]"></ng-content>
    <ng-content select="[banner]"></ng-content>
    <ng-container *ngIf="!isFilterHidden">
        <div
            fxLayout="row wrap"
            fxLayoutGap="10px"
            class="status-message"
            *ngIf="statusCounts || activeCounts || !shouldHideSearch || !shouldHideRefresh"
        >
            <ng-container *ngIf="shouldPlaceSearchLeft; else defaultFilterLayout">
                <ng-container *ngTemplateOutlet="searchFilter"></ng-container>
                <ng-container *ngTemplateOutlet="buttonFilters"></ng-container>
            </ng-container>
            <ng-template #defaultFilterLayout>
                <ng-container *ngTemplateOutlet="buttonFilters"></ng-container>
                <ng-container *ngTemplateOutlet="searchFilter"></ng-container>
            </ng-template>

            <ng-template #buttonFilters>
                <clare-status-filter
                    *ngIf="statusCounts"
                    class="tbl-filter tbl-status-count"
                    fxFlex.gt-md="1 1 38%"
                    fxLayoutGap="10px"
                    [initialActiveFilters]="initialStatusFilters?.['onlineStatus']"
                    filterColumn="onlineStatus"
                    [statusCounts]="statusCounts"
                    (changeFilterHandler)="onFilterChange($event)"
                ></clare-status-filter>
                <clare-status-filter
                    *ngIf="activeCounts"
                    class="tbl-filter"
                    fxFlex
                    fxLayoutGap="10px"
                    filterColumn="inactive"
                    [initialActiveFilters]="initialStatusFilters?.['inactive']"
                    [statusCounts]="activeCounts"
                    (changeFilterHandler)="onFilterChange($event)"
                ></clare-status-filter>
            </ng-template>
            <ng-template #searchFilter>
                <div fxLayoutAlign="space-around center" class="tbl-filter" fxFlex *ngIf="!shouldHideSearch || !shouldHideRefresh">
                    <clare-search
                        fxFlex="1 1"
                        *ngIf="!shouldHideSearch"
                        [initialValue]="initialQueryString"
                        (searchDataHandler)="onDataSearch($event)"
                    ></clare-search>
                    <mat-icon id="btnRefresh" fxFlex="0 1 auto" *ngIf="!shouldHideRefresh" (click)="onDataRefresh()"> refresh </mat-icon>
                </div>
            </ng-template>
            <div><!-- spacer for flexGrid //--></div>
        </div>
    </ng-container>
</div>
